import { useLocation, useNavigate } from "react-router-dom";
import { Chip, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

import typography from "../../../theme/typography";
import { colors } from "../../../theme/palette";
import APP_ROUTES from "../../../routers/routeConstants";

export const MenuItem = ({ to, label, icon }: { to?: string; label: string; icon: JSX.Element }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const IS_DASHBOARD_ITEM = to === APP_ROUTES.DASHBOARD;
  const IS_DASHBOARD_ACTIVE = to === APP_ROUTES.DASHBOARD && location.pathname === APP_ROUTES.DASHBOARD;

  const isActive = IS_DASHBOARD_ITEM ? IS_DASHBOARD_ACTIVE : !!to && location.pathname.startsWith(to);

  return (
    <li>
      <Link
        sx={{
          position: "relative",
          textDecoration: "none",
          ...typography.body14Regular,
          color: isActive ? colors.Dark1000 : colors.dark600,
          padding: "8px 12px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          borderRadius: "6px",
          gap: "12px",
          background: isActive ? colors.Gray50 : "transparent",
          ...(isActive && typography.body14SemiBold),
          "& svg path": {
            stroke: isActive ? colors.Green100 : colors.Dark600,
          },
          ...(to && {
            "&:hover": {
              cursor: "pointer",
              ...typography.body14SemiBold,
              background: colors.Gray50,
              "& svg path": {
                stroke: colors.Green100,
              },
            },
          }),
        }}
        onClick={() => (to ? navigate(to) : "")}
      >
        {icon}
        {label}
        {!to && (
          <Chip
            sx={{
              borderRadius: "8.5px",
              background: colors.SecondaryMint,
              padding: "1px 8px",
              ...typography.body10Regular,
              color: colors.GreenDarkMode,
              marginLeft: "auto",
              height: "fit-content",
              "& .MuiChip-label": {
                padding: "0",
              },
            }}
            label={t("layout.sideNav.soon")}
          />
        )}
      </Link>
    </li>
  );
};

export default MenuItem;
